import {IResource} from '@simpli/resource-collection/dist/types/IResource'

export class OrbitTransactionGroupSummary implements IResource {
  address: string | null = null
  idOrbitRoundFk: number | null = null
  round: number | null = null
  networkIdentifier: string | null = null
  totalTxs: number = 0
  createdAt: Date | string | number | null = null
  updatedAt: Date | string | number | null = null

  get $id() {
    return Number(this.idOrbitRoundFk)
  }

  get $tag() {
    return String(this.$id)
  }
}
